var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRoughIntro = function SvgRoughIntro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10 L2,2 C7.60672261,2 7.01413002,2 10,2",
    transform: "translate(3 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20 L12,12 C17.6067226,12 17.01413,12 20,12",
    transform: "rotate(-180 17.5 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1L15 7 21 7",
    transform: "translate(3 4)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 5.5 19)",
    d: "M1 14L1 20 7 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6.46608167 L20.3728653,1",
    transform: "rotate(6 -18.476 34.355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00966609,20.023177 L5.81487023,14.932989",
    transform: "rotate(2 -109.668 105.413)"
  }))));
};
export default SvgRoughIntro;